import React, { useState } from "react";
import api from "../service/api";
import { Loader2, Play, Download, Printer, FileSpreadsheet } from "lucide-react";
import * as XLSX from "xlsx";

interface ReportGridProps {
  endpoint: string;
  columns: any[];
  filters?: any;
  reportName?: string;
  extraFilters?: React.ReactNode; // Tarih seçicileri buraya gelecek
}

export const ReportGrid = ({ 
  endpoint, 
  columns, 
  filters, 
  reportName = "Rapor",
  extraFilters 
}: ReportGridProps) => {
  const [data, setData] = useState<any[]>([]);
  const [loading, setLoading] = useState(false);

  const runReport = async () => {
    setLoading(true);
    try {
      const res = await api.get(endpoint, { params: filters });
      // Backend formatına göre veriyi seç
      const result = Array.isArray(res.data) ? res.data : (res.data.details || res.data.accounts || []);
      setData(result);
    } catch (error) {
      console.error("Rapor çekilemedi:", error);
    } finally {
      setLoading(false);
    }
  };

  const exportToExcel = () => {
    const exportData = data.map(row => {
      const obj: any = {};
      columns.forEach(col => {
        // Eğer body varsa içindeki metni almaya çalış, yoksa field'ı al
        obj[col.header] = col.field ? row[col.field] : "Detaylı Veri";
      });
      return obj;
    });

    const worksheet = XLSX.utils.json_to_sheet(exportData);
    const workbook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(workbook, worksheet, "Rapor");
    XLSX.writeFile(workbook, `${reportName}_${new Date().toLocaleDateString()}.xlsx`);
  };

  return (
    <div className="flex flex-col   gap-4">
      {/* KONTROL PANELİ: Filtreler ve Butonlar */}
      <div className="flex flex-wrap items-center justify-between card2 no-print gap-4 shadow-sm">
        
        {/* SOL: Rapor İsmi */}
        <div className="flex items-center gap-3">
          <div className="hidden sm:block p-2 card">
            <Play size={18} fill="currentColor" />
          </div>
          <div>
            <h3 className="text-sm font-bold  ">{reportName}</h3>
          </div>
        </div>

        {/* SAĞ: Filtreler (Tarih vb.) + Butonlar */}
        <div className="flex flex-wrap items-center gap-2">
          
          {/* DIŞARIDAN GELEN TARİH SEÇİCİLER (Sorgula butonunun solunda) */}
          {extraFilters && (
            <div className="flex items-center gap-2 pr-2  ">
              {extraFilters}
            </div>
          )}

          {/* SORGULA BUTONU */}
          <button 
            onClick={runReport}
            disabled={loading}
            className="flex items-center gap-2 px-5 py-2 text-sm font-bold  btn-new"
          >
            {loading ? <Loader2 className="w-4 h-4 animate-spin" /> : <Play size={14} />}
            Sorgula
          </button>

          {/* AKSİYONLAR (Excel & Yazdır) */}
          {data.length > 0 && (
            <div className="flex items-center gap-1 ml-1 pl-2  ">
              <button 
                onClick={exportToExcel} 
                title="Excel İndir"
                className="p-2 text-emerald-600 border border-emerald-600 rounded-md"
              >
                <FileSpreadsheet size={18} />
              </button>
              <button 
                onClick={() => window.print()} 
                title="Yazdır"
                className="p-2 text-blue-500 border border-blue-500 rounded-md"
              >
                <Printer size={18} />
              </button>
            </div>
          )}
        </div>
      </div>

      {/* TABLO ALANI */}
      <div className="overflow-hidden border card2 shadow-sm flex-1 min-h-[250px]">
        <div className="overflow-x-auto">
          <table className="w-full text-sm text-left border-collapse">
            <thead className="card uppercase text-[10px] font-black  ">
              <tr>
                {columns.map((col, i) => (
                  <th key={i} className="px-6 py-4 tracking-wider">{col.header}</th>
                ))}
              </tr>
            </thead>
            <tbody className="   ">
              {data.length === 0 ? (
                <tr>
                  <td colSpan={columns.length} className="px-6 py-24 text-center  ">
                    <div className="flex flex-col items-center gap-3">
                      <div className="p-4   rounded-full">
                        <Play size={32} className="opacity-20  " />
                      </div>
                      <p className="font-medium">Sorgulama kriterlerini belirleyip raporu çalıştırın.</p>
                    </div>
                  </td>
                </tr>
              ) : (
                data.map((row, rowIndex) => (
                  <tr key={rowIndex} className="  transition-colors">
                    {columns.map((col, colIndex) => (
                      <td key={colIndex} className="px-6 py-4   font-medium">
                        {col.body ? col.body(row) : (col.field ? row[col.field] : "-")}
                      </td>
                    ))}
                  </tr>
                ))
              )}
            </tbody>
          </table>
        </div>
      </div>
    </div>
  );
};